import { render, staticRenderFns } from "./QueueCompanyItem.vue?vue&type=template&id=3938b536&scoped=true"
import script from "./QueueCompanyItem.vue?vue&type=script&lang=js"
export * from "./QueueCompanyItem.vue?vue&type=script&lang=js"
import style0 from "./QueueCompanyItem.vue?vue&type=style&index=0&id=3938b536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3938b536",
  null
  
)

export default component.exports